/**
 * Dropdown Menu Functionality
 * Handles dropdown menu toggling for desktop and mobile views
 */

// Toggle dropdown menu for mobile view
export function toggleDropdown(event) {
  // Always prevent default behavior for button toggles
  event.preventDefault();
  event.stopPropagation();

  const isMobile = window.innerWidth <= 1280;
  const toggleButton = event.currentTarget;
  
  if (isMobile) {
    console.log('Mobile dropdown toggle clicked', toggleButton);
    
    // Find the dropdown menu by navigating from the button to its parent nav-dropdown
    const navDropdown = toggleButton.closest('.nav-dropdown');
    const dropdownMenu = navDropdown ? navDropdown.querySelector('.dropdown-menu') : null;
    
    // Close any other open dropdowns
    const allToggleButtons = document.querySelectorAll('.dropdown-toggle');
    allToggleButtons.forEach(button => {
      if (button !== toggleButton) {
        button.classList.remove('active');
        const otherNavDropdown = button.closest('.nav-dropdown');
        const otherMenu = otherNavDropdown ? otherNavDropdown.querySelector('.dropdown-menu') : null;
        if (otherMenu) {
          otherMenu.classList.remove('show');
        }
      }
    });
    
    // Toggle active class on dropdown toggle
    toggleButton.classList.toggle('active');
    
    // Toggle show class on dropdown menu
    if (dropdownMenu) {
      dropdownMenu.classList.toggle('show');
      console.log('Toggling dropdown menu visibility', dropdownMenu);
    } else {
      console.error('Could not find dropdown menu element');
    }
  }
}

// Close all dropdowns when clicking outside
function closeDropdowns(event) {
  // Don't close if we clicked on a dropdown toggle or inside a dropdown
  const isDropdownToggle = event.target.closest('.dropdown-toggle');
  const isDropdownMenu = event.target.closest('.dropdown-menu');
  
  if (!isDropdownToggle && !isDropdownMenu) {
    const allToggleButtons = document.querySelectorAll('.dropdown-toggle');
    allToggleButtons.forEach(button => {
      button.classList.remove('active');
      const navDropdown = button.closest('.nav-dropdown');
      const menu = navDropdown ? navDropdown.querySelector('.dropdown-menu') : null;
      if (menu) {
        menu.classList.remove('show');
      }
    });
  }
}

// Initialize dropdown menu functionality
export function initDropdowns() {
  const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
  
  dropdownToggles.forEach(toggle => {
    // Remove any existing event listeners first
    toggle.removeEventListener('click', toggleDropdown);
    
    // Add the click event listener
    toggle.addEventListener('click', toggleDropdown);
    console.log('Added click event to dropdown toggle:', toggle);
  });
  
  // Add document click listener to close dropdowns when clicking outside
  document.removeEventListener('click', closeDropdowns);
  document.addEventListener('click', closeDropdowns);
} 